module.exports = __webpack_public_path__ + "static/media/AZUCAR.ab2e5189.jpg";